import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { useDrinkCustomization } from './contexts/DrinkCustomizationContext';
import { useAppSettings } from './contexts/AppSettingsContext';
import * as apiService from './services/apiService';
import HomeScreen from './pages/HomeScreen';
import DrinkSelectionScreen from './pages/DrinkSelectionScreen';
// import CustomizeDrinkScreen from './pages/CustomizeDrinkScreen';
// import PlaceContainerScreen from './pages/PlaceContainerScreen';
import PaymentScreen from './pages/PaymentScreen';
import DispensingScreen from './pages/DispensingScreen';
// import CompletionScreen from './pages/CompletionScreen';
import HwScreen from './pages/HwScreen';
import SM16RelindControlScreen from './pages/SM16RelindControlScreen';
import FlowMeterControlScreen from './pages/FlowMeterControlScreen';
import SendRecapScreen from './pages/SendRecapScreen';
import './App.css';
import './common-style.css';
import ScalingWrapper from './components/ScalingWrapper';

const MainLayout = () => {
  const { setDrinks, setIsLoading } = useDrinkCustomization();
  const { appSettingsReady, loadSettings } = useAppSettings();

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  useEffect(() => {
    const loadDrinks = async () => {
      setIsLoading(true);
      try {
        const data = await apiService.fetchAllDrinks();
        setDrinks(data);
      } catch (error) {
        console.error("Failed to fetch drinks:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (appSettingsReady) {
      loadDrinks();
    }
  }, [appSettingsReady, setDrinks, setIsLoading]);

  return (
    <ScalingWrapper>
      <Outlet />
    </ScalingWrapper>
  );
};

function App() {
  const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true';

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/select-drink" element={<DrinkSelectionScreen />} />
            {/* <Route path="/customize-drink" element={<CustomizeDrinkScreen />} /> */}
            <Route path="/payment" element={<PaymentScreen />} />
            {/* <Route path="/place-container" element={<PlaceContainerScreen />} /> */}
            <Route path="/dispensing" element={<DispensingScreen />} />
            {/* <Route path="/completion" element={<CompletionScreen />} /> */}
          </Route>
          {/* TODO: merge the following two screens into one where the user can select the type of hardware to control */}
          {!isDemoMode && (
            <>
              {/* /* Hardware control screen */}
              <Route path="/hw" element={<HwScreen />} />
              {/* /* SM16 Relay control screen */}
              <Route path="/re" element={<SM16RelindControlScreen />} />
              {/* /* Flow meter control screen */}
              <Route path="/fm" element={<FlowMeterControlScreen />} />
              {/* /* Send recap email screen */}
              <Route path="/sr" element={<SendRecapScreen />} />
            </>
          )}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
